import { Button } from "@devhop/ui";
import { HelpCircle, PlusIcon } from "lucide-react";

type ServiceStandardToolbarProps = {
  canManage: boolean;
  onCreate: () => void;
  onStartTour?: () => void;
};

export function ServiceStandardToolbar({
  canManage,
  onCreate,
  onStartTour,
}: ServiceStandardToolbarProps) {
  return (
    <div className="mb-2 flex flex-col gap-4">
      <div className="flex flex-wrap items-center justify-between space-y-2">
        <div>
          <div className="flex items-center space-x-2">
            <h2 className="font-bold text-2xl tracking-tight">
              ລາຍການມາດຕະຖານບໍລິການ
            </h2>
            <Button
              variant="ghost"
              size="icon"
              className="size-7 rounded-full"
              onClick={onStartTour}
            >
              <HelpCircle className="size-5" />
            </Button>
          </div>
          <p className="text-muted-foreground">
            ຈັດການມາດຕະຖານບໍລິການ (Service Standard).
          </p>
        </div>
        {canManage && (
          <div className="flex items-center space-x-2">
            <div data-tourid="service-standard-toolbar">
              <Button onClick={onCreate}>
                <PlusIcon className="h-4 w-4" />
                ສ້າງມາດຕະຖານບໍລິການໃໝ່
              </Button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

